module.exports = __webpack_public_path__ + "img/weddingRingsFacettedConnections-emotion-02@2x.eb670e2.jpg";